﻿import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { client } from '../gothia-cup/axios';
import QRCode from 'react-qr-code';
import { LoadSpinner } from '../../components/loadspinner/LoadSpinner';

export default function QrList() {
  const { id: eventId } = useParams();
  const [attendees, setAttendees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAttendees = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await client.get(`/attendee/GetQrList`, {
        params: { eventId },
      });
      setAttendees(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    fetchAttendees();
  }, [fetchAttendees]);

  return (
    <div className="snap-y snap-mandatory flex items-center justify-center w-screen h-screen overflow-auto">
      <div className='h-screen'>
        {attendees?.map(({ badgeNo, firstName, lastName }) => (
          <div className="snap-start h-full w-full" key={badgeNo}>
            <div className="flex items-center gap-5 mx-auto w-full h-full">
              <QRCode key={badgeNo} value={badgeNo} size={200} />
              <h3 className="text-2xl">
                {firstName} {lastName}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
